/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "org-account-e6c88953--sprite",
  "use": "org-account-e6c88953--sprite-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"org-account-e6c88953--sprite\"><g transform=\"translate(36 36) rotate(180)\"><g transform=\"translate(36 36) rotate(180)\" opacity=\"0\"><g fill=\"#fff\" stroke=\"#707070\" stroke-width=\"1\" opacity=\"0.5\"><rect width=\"36\" height=\"36\" stroke=\"none\" /><rect x=\"0.5\" y=\"0.5\" width=\"35\" height=\"35\" fill=\"none\" /></g></g></g><g transform=\"translate(9065 18329)\"><path d=\"M-473.252,316.21v1.449a1.45,1.45,0,0,1-1.449,1.449h-1.449a1.447,1.447,0,0,1-1.449-1.449V316.21a1.447,1.447,0,0,1,1.449-1.449h.522V312.83h-7.283v1.932h.483a1.45,1.45,0,0,1,1.449,1.449v1.449a1.45,1.45,0,0,1-1.449,1.449h-1.449a1.447,1.447,0,0,1-1.449-1.449V316.21a1.447,1.447,0,0,1,1.449-1.449h.483V312.83h-7.282v1.932h.522a1.45,1.45,0,0,1,1.449,1.449v1.449a1.45,1.45,0,0,1-1.449,1.449H-491.6a1.447,1.447,0,0,1-1.449-1.449V316.21a1.447,1.447,0,0,1,1.449-1.449h.445v-2.415h7.765v-1.932h-.483a1.447,1.447,0,0,1-1.449-1.449v-1.449a1.447,1.447,0,0,1,1.449-1.449h1.449a1.45,1.45,0,0,1,1.449,1.449v1.449a1.45,1.45,0,0,1-1.449,1.449h-.483v1.932h7.766v2.415h.444A1.45,1.45,0,0,1-473.252,316.21Z\" transform=\"translate(-8563.849 -18624.643)\" fill=\"currentColor\" /></g></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
